<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app,
html,
body {
  height: 100vh;
  width: 100vw;
  /* overflow: hidden; */
}

* {
  padding: 0;
  margin: 0;
}
</style>

<!-- <template>
  <div id="app">
    <EZUIKitJs />
  </div>
</template>

<script>
import EZUIKitJs from "./components/EZUIKitJs.vue";

export default {
  name: "App",
  components: {
    EZUIKitJs,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style> -->
